import React, { useEffect } from 'react';
import { useNotifications } from '../contexts/NotificationContext';

/**
 * Composant qui affiche des notifications liées à l'authentification via le système de notifications
 * - Expiration du token nécessitant une reconnexion
 * Note: Les notifications de rafraîchissement automatique du token ont été désactivées pour éviter le spam utilisateur
 */
const AuthNotification = () => {
  const { addSystemNotification } = useNotifications();

  useEffect(() => {
    // Écouteur pour l'expiration du token Azure
    const handleTokenExpired = () => {
      addSystemNotification('Votre session a expiré. Veuillez vous reconnecter.', 'error');
    };

    // Ajouter les écouteurs d'événements personnalisés
    window.addEventListener('azure-token-expired', handleTokenExpired);

    // Supprimer les écouteurs à la destruction du composant
    return () => {
      window.removeEventListener('azure-token-expired', handleTokenExpired);
    };
  }, [addSystemNotification]);

  // Ce composant ne rend rien car il utilise maintenant le système de notifications
  return null;
};

export default AuthNotification; 